import(/* webpackMode: "eager", webpackExports: ["MarketingPageShell","ServicesPageContent"] */ "/opt/render/project/src/src/modules/landing/pages/LandingPage.tsx");
